import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  Icon,
  Image,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  Spinner,
  Text,
  VStack,
  chakra,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { IoIosAlert, IoMdCalendar } from 'react-icons/io';
import useModelMedicos from './useModelMedicos';
import BackButton from '../../../../../../images/assets/telemedicina/backbutton.svg';
import Heart from '../../../../../../images/dashboard/visitante.png';
import Notificacao from '../../../../../../images/dashboard/notificacao.png';
import { StarIcon } from '@chakra-ui/icons';

function MedicosEspecialistas() {
  const [modalAviso, setModalAviso] = useState(false);
  const {
    error,
    loading,
    especialista,
    modalEspecialista,
    setModalEspecialista,
    navigate,
    agendamento,
    atualizarAgendamento,
    medicos,
    avaliacoes_atualizadas,
    assinante,
    setMedicoSelecionado,
    user,
    toastInadimplente,
    proximasDatas,
  } = useModelMedicos();
  const [imgLoaded, setImgLoaded] = React.useState(false);
  const isLoading = loading;
  const [localLoading, setLocalLoading] = React.useState(false);
  useEffect(() => {
    setLocalLoading(true);
    const timer = setTimeout(() => setLocalLoading(false), 900);
    return () => clearTimeout(timer);
  }, [agendamento?.especialidadeId]);

  const formatarEspecialidade = (txt) => txt?.toLowerCase()?.replace(/^\w/, (c) => c.toUpperCase());

  const drawerEspecialista = () => {
    return (
      <>
        <Drawer isOpen={modalEspecialista} placement="bottom" onClose={() => setModalEspecialista(false)}>
          <DrawerOverlay />
          <DrawerContent borderTopRadius="20px" pb={4} w="100%" maxH="70vh" overflow="hidden" bg="white">
            <Box w="50px" h="6px" bg="#E0E0E0" borderRadius="full" mx="auto" mt={3} mb={2} />
            <DrawerBody p={0}>
              <VStack spacing={3} w="100%" maxH="65vh" overflowY="auto" px={4} pb={5}>
                {especialista?.map((item) => {
                  const disponivel = item?.profissionais_disponiveis > 0;
                  const selecionado = false;

                  return (
                    <Flex
                      key={item?.id}
                      w="100%"
                      align="center"
                      justify="space-between"
                      p={3}
                      borderRadius="lg"
                      cursor="pointer"
                      bg={selecionado ? '#2AA39A' : 'white'}
                      transition="0.15s"
                      _hover={{
                        bg: selecionado ? '#2AA39A' : '#F4F7F7',
                      }}
                      onClick={() => {
                        console.log('Clicou na especialidade:', item);
                        setModalEspecialista(false);
                      }}
                      boxShadow="sm"
                    >
                      <HStack spacing={3}>
                        <Flex
                          bg={selecionado ? 'white' : '#E6F4F3'}
                          w="38px"
                          h="38px"
                          borderRadius="full"
                          align="center"
                          justify="center"
                          boxShadow="inner"
                        >
                          <Image src={Heart} w="18px" h="18px" />
                        </Flex>

                        <Text
                          fontWeight="600"
                          fontSize="md"
                          color={selecionado ? 'white' : '#4A4A4A'}
                          maxW="150px"
                          whiteSpace="normal"
                          wordBreak="break-word"
                          onClick={() => {
                            atualizarAgendamento({ especialidadeId: item?.ambulatorio_tipo_consulta_id });
                          }}
                        >
                          {formatarEspecialidade(item?.descricao)}
                        </Text>
                      </HStack>

                      <Flex
                        bg={disponivel ? 'rgba(197, 232, 190, 0.8)' : 'rgba(249, 228, 199, 0.9)'}
                        color={disponivel ? '#0F7A00' : '#C96F1B'}
                        px={3}
                        py={1.5}
                        borderRadius="full"
                        fontWeight="600"
                        minW="120px"
                        maxW="150px"
                        justify="center"
                        align="center"
                        textAlign="center"
                        fontSize="0.75em"
                        gap={2}
                        flexShrink={0}
                      >
                        {disponivel ? (
                          `${item?.profissionais_disponiveis} ${
                            item?.profissionais_disponiveis > 1 ? 'profissionais disponíveis' : 'profissional disponível'
                          } `
                        ) : (
                          <>
                            <Image src={Notificacao} boxSize="16px" objectFit="contain" />
                            Avisar disponibilidade
                          </>
                        )}
                      </Flex>
                    </Flex>
                  );
                })}
              </VStack>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </>
    );
  };

  const AvaliacaoEstrela = ({ avaliacao }) => {
    const [avaliacaoMedia, setAvaliacaoMedia] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
const formatarAvaliacao = (media) => {
  const valor = Math.floor(media * 10) / 10;
  return valor.toFixed(1);
};

    useEffect(() => {
      if (avaliacao) {
        const media =
          !avaliacao.avaliacao_media || avaliacao.avaliacao_media === '0' ? 5 : avaliacao.avaliacao_media >= 1 ? avaliacao.avaliacao_media : 5;

        setAvaliacaoMedia(formatarAvaliacao(media));
        setIsLoading(false);
      }
    }, [avaliacao]);

    return (
      <chakra.span mt={-0.5}>
        <StarIcon color="orange" fontSize="1em" mt={-0.3} />
        <chakra.span fontSize="0.625em" color="orange" fontWeight={600}>
          {isLoading ? <Spinner size="sm" color="#5ab2ae" /> : avaliacaoMedia}
        </chakra.span>
      </chakra.span>
    );
  };

  const tratarNome = (nomeCompleto) => {
    if (!nomeCompleto) return '';

    const capitalizar = (palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();

    const partes = nomeCompleto.trim().split(/\s+/).filter(Boolean);

    if (partes.length === 0) return '';

    const primeiroNome = capitalizar(partes[0]);

    if (partes.length === 1) return primeiroNome;

    const segundoNome = capitalizar(partes[1]);

    return `${primeiroNome} ${segundoNome}`;
  };

  let data_parcela = '';
  if (user?.qntdeParcelas?.countParcelas > 0) {
    data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
    }
  }
  const dataAtual = new Date();
  const clientePendente = user?.loggedIn && user?.qntdeParcelas?.countParcelas && user?.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela;

  useEffect(() => {
    if (!clientePendente && user?.loggedIn) {
      toastInadimplente(user?.id_forma_pagamento, user?.qntdeParcelas);
    }
  }, [assinante, clientePendente, user?.loggedIn]);

  return (
    <>
      <VStack bg="#5AB2AE" minH="100vh" w="100%" spacing={0}>
        <HStack
          bg="#5AB2AE"
          borderRadius="1em"
          p={3}
          w={{ base: '98%', sm: '96%' }}
          maxW="480px"
          spacing={2}
          position="fixed"
          top="calc(env(safe-area-inset-top, 0px) + 0.5em)"
          left="50%"
          transform="translateX(-50%)"
          justify="center"
          align="center"
          zIndex={10}
        >
          <SkeletonCircle isLoaded={imgLoaded} size={{ base: '24px', sm: '28px' }}>
            <Image
              src={BackButton}
              onClick={() => navigate(-1)}
              cursor="pointer"
              boxSize={{ base: '24px', sm: '28px' }}
              onLoad={() => setImgLoaded(true)}
            />
          </SkeletonCircle>
          <Skeleton isLoaded={!isLoading} flex={1} borderRadius="8px">
            <Text fontSize={{ base: '1em', sm: '1.3em' }} color="white" fontWeight="bold" textAlign="center">
              Telemedicina Especialista
            </Text>
          </Skeleton>
        </HStack>

        <Flex
          w="100%"
          minH="100vh"
          align="center"
          justify="center"
          pt={{ base: 'calc(env(safe-area-inset-top, 0px) + 5em)', sm: 'calc(env(safe-area-inset-top, 0px) + 6em)' }}
        >
          <VStack
            bg="white"
            w={{ base: '98%', sm: '95%' }}
            maxW="500px"
            borderRadius="1em"
            spacing={5}
            p={{ base: 2, sm: 4 }}
            justify="space-between"
          >
            <VStack spacing={4} w="100%" p={4} alignItems="flex-start" mt={2}>
              <SkeletonText isLoaded={!isLoading} noOfLines={1} w="100%">
                <Text color="#616161" fontWeight="bold" mb={-3}>
                  Encontre seu especialista!
                </Text>
              </SkeletonText>

              <Skeleton isLoaded={!isLoading} w="100%" h="3em" borderRadius="0.8em">
                <Text
                  name="especialistas"
                  borderRadius="0.8em"
                  textAlign="left"
                  fontWeight="normal"
                  backgroundColor="#EEEEEE"
                  h="3em"
                  w="100%"
                  display="flex"
                  alignItems="center"
                  pl={3}
                  cursor="pointer"
                  _focus={{ borderColor: '#5AB2AE' }}
                  onClick={() => setModalEspecialista(true)}
                  disabled={loading}
                >
                  {agendamento?.especialidadeId
                    ? especialista?.find((e) => e.ambulatorio_tipo_consulta_id === agendamento.especialidadeId)?.descricao
                    : loading
                    ? 'Carregando especialistas...'
                    : 'Filtrar Especialistas'}
                </Text>
              </Skeleton>
            </VStack>

            <Box
              w="100%"
              h="450px"
              maxH="450px"
              minH="450px"
              overflowY="auto"
              borderRadius="1em"
              boxShadow="sm"
              bg="#F9F9F9"
              transition="height 0.3s"
            >
              <VStack w="100%" spacing={4} h="100%" justify="flex-start">
                {localLoading || loading
                  ? Array.from({ length: 4 }).map((_, idx) => (
                      <Flex key={idx} align="center" bg="#F4F7F7" borderRadius="2em" p={3} mb={2} boxShadow="md" w="100%" opacity={0.7}>
                        <SkeletonCircle size="56px" mr={4} />
                        <Box flex="1">
                          <Skeleton height="20px" mb={2} borderRadius="md" />
                          <Skeleton height="16px" mb={1} borderRadius="md" />
                          <Skeleton height="16px" width="60px" borderRadius="md" />
                        </Box>
                        <Skeleton height="36px" width="90px" borderRadius="2em" />
                      </Flex>
                    ))
                  : medicos &&
                    medicos.length > 0 &&
                    medicos.map((medico, idx) => {
                      const avaliacao = avaliacoes_atualizadas.find((avaliacao) => avaliacao.operador_id === medico.dados.medico_id);
                      const proximasDoMedico = medico?.proximasDatas || [];
                      const proxima_data = proximasDoMedico.length
                        ? proximasDoMedico.reduce((maisProxima, atual) => (new Date(atual.data) < new Date(maisProxima.data) ? atual : maisProxima))
                        : null;
                      return (
                        <Flex key={idx} align="center" bg="#F4F7F7" borderRadius="2em" p={3} mb={2} boxShadow="md" w="100%" flexWrap="wrap">
                          <Image
                            src={
                              medico?.foto ||
                              medico?.dados?.foto ||
                              'https://ui-avatars.com/api/?name=' + encodeURIComponent(medico?.dados?.nome || medico?.nome || 'Médico')
                            }
                            alt={medico?.dados?.nome || medico?.nome}
                            boxSize="56px"
                            borderRadius="full"
                            mr={4}
                          />
                          <Box flex="1" minW="180px" pr={2}>
                            <HStack w="100%" justify="space-between" align="center">
                              <Text fontWeight="bold" fontSize="md" color="#5AB2AE" isTruncated>
                                {medico?.dados?.sexo === 'F' ? 'Dra. ' : 'Dr. '} {tratarNome(medico?.dados?.nome || medico?.nome)}
                              </Text>

                              <AvaliacaoEstrela avaliacao={avaliacao} />
                            </HStack>

                            <Text fontSize="sm" color="#4A4A4A" noOfLines={2} maxW="180px" wordBreak="break-word">
                              {medico?.dados?.especialidade || medico?.especialidade}
                            </Text>
                            <Text fontSize="sm" color="#818181" noOfLines={2} maxW="180px" wordBreak="break-word">
                              {medico?.dados?.conselho && medico?.dados?.conselho} {medico?.dados?.conselho && medico?.dados?.rqe && ' '}{' '}
                              {medico?.dados?.rqe && medico?.dados?.rqe}
                            </Text>
                          </Box>
                          <Flex mt={4} w="100%" align="center" justify="space-between" flexDirection={{ base: 'column', sm: 'row' }} gap={3}>
                            <Text fontSize="md" color="#348e89" fontWeight="bold" whiteSpace="nowrap" flexShrink={0}>
                              {(() => {
                                // Para usuários deslogados, mostra o valor particular
                                if (!user?.loggedIn) {
                                  const valorParticular = Number(
                                    medico?.horarios[0]?.procedimentos[0]?.procedimento_particular?.valor || 0
                                  );
                                  return valorParticular === 0 ? 'Consultar Valor' : `R$ ${valorParticular.toFixed(0)}`;
                                }

                                // Lógica existente para usuários logados
                                const faltou = false; // Desabilitado conforme solicitado
                                const valorConsulta = Number(medico?.horarios[0]?.procedimentos[0]?.valor || 0);
                                const valorParticular = Number(
                                  medico?.horarios[0]?.procedimentos[0]?.procedimento_particular?.valor || 0
                                );
                                const telemedicinaGratis = agendamento?.telemedicina_especialista_gratis;

                                let valor = 0;
                                let showAlert = false;
                                if (telemedicinaGratis) {
                                  if (faltou) {
                                    valor = valorConsulta * 0.5;
                                    showAlert = true;
                                  } else {
                                    valor = 0;
                                  }
                                } else if (faltou) {
                                  if (assinante && !clientePendente) {
                                    valor = valorConsulta * 0.5;
                                  } else {
                                    valor = valorParticular * 0.5;
                                  }
                                  showAlert = true;
                                } else if (assinante && !clientePendente) {
                                  valor = valorConsulta;
                                } else {
                                  valor = valorParticular;
                                }
                                return (
                                  <>
                                    {valor === 0 ? 'Gratuito' : `R$ ${valor.toFixed(0)}`}
                                    {showAlert && (
                                      <Icon as={IoIosAlert} color="#D62422" ml={2} boxSize={6} cursor="pointer" onClick={() => setModalAviso(true)} />
                                    )}
                                  </>
                                );
                              })()}
                            </Text>

                            <Button
                              fontWeight="normal"
                              colorScheme="teal"
                              borderRadius="2em"
                              px={6}
                              w={{ base: '100%', sm: 'auto' }}
                              minW="fit-content"
                              flexShrink={0}
                              fontSize="sm"
                              leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 5, sm: 5 }} flexShrink={0} />}
                              onClick={() => {
                                if (!user?.loggedIn) {
                                  // Redireciona para login se usuário não estiver logado
                                  navigate('/login');
                                  return;
                                }
                                atualizarAgendamento({
                                  medicoId: medico?.dados?.medico_id || medico?.medico_id,
                                });
                                setMedicoSelecionado({ medico: medico.dados, horarios: medico.horarios, avaliacao: avaliacao });
                                navigate('/horarios');
                              }}
                            >
                              {!user?.loggedIn ? (
                                'Fazer Login para Agendar'
                              ) : (
                                <>
                                  Próxima data:{' '}
                                  {!proxima_data ? (
                                    <Spinner size="sm" color="teal.500" ml={2} />
                                  ) : proxima_data?.data ? (
                                    (() => {
                                      const d = new Date(proxima_data?.data);
                                      const dia = String(d.getDate()).padStart(2, '0');
                                      const mes = String(d.getMonth() + 1).padStart(2, '0');
                                      const ano = String(d.getFullYear()).slice(-2);
                                      return `${dia}/${mes}/${ano}`;
                                    })()
                                  ) : (
                                    '---'
                                  )}
                                </>
                              )}
                            </Button>
                          </Flex>
                        </Flex>
                      );
                    })}

                {agendamento?.especialidadeId !== null && medicos.length === 0 && !loading && !localLoading && (
                  <>
                    <Text color="#616161" fontSize="1em" fontWeight="bold" textAlign="center" mt={10} mb={10}>
                      Nenhum médico encontrado para a especialidade selecionada.
                    </Text>
                  </>
                )}
                {error && (
                  <Text color="red.500" fontSize="0.9em" textAlign="left" fontWeight={'bold'} lineHeight={1} w="90%">
                    {error}
                  </Text>
                )}
              </VStack>
            </Box>
          </VStack>
        </Flex>

        {modalEspecialista && drawerEspecialista()}
        {modalAviso && (
          <Box
            position="fixed"
            top={0}
            left={0}
            w="100vw"
            h="100vh"
            bg="rgba(0,0,0,0.3)"
            zIndex={9999}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Box bg="white" p={6} borderRadius="lg" boxShadow="lg" maxW="90vw" minW="280px" textAlign="center">
              <Text fontWeight="bold" color="#D62422" mb={3} fontSize="lg">
                Aviso
              </Text>
              <Text color="#333" fontSize="md" mb={4}>
                O valor cobrado refere-se a uma multa de 50% do valor da consulta, aplicada por faltas em atendimentos anteriores no período de 60
                dias.
              </Text>
              <Button colorScheme="red" onClick={() => setModalAviso(false)}>
                Fechar
              </Button>
            </Box>
          </Box>
        )}
      </VStack>
    </>
  );
}

export default React.memo(MedicosEspecialistas);
